// Human messages for working-hours problems, in Arabic and English.
// The server answers an invalid hours request with `details`
// ({ issue, day, shift }); the editor produces the same shape locally, so both
// say exactly which day and which shift to fix.

const DAYS = {
  sunday: ["الأحد", "Sunday"],
  monday: ["الاثنين", "Monday"],
  tuesday: ["الثلاثاء", "Tuesday"],
  wednesday: ["الأربعاء", "Wednesday"],
  thursday: ["الخميس", "Thursday"],
  friday: ["الجمعة", "Friday"],
  saturday: ["السبت", "Saturday"],
};
// "morning" is the first shift and "evening" the second one.
const SHIFTS = { morning: ["الفترة الأولى", "First shift"], evening: ["الفترة الثانية", "Second shift"] };

export const describeHoursProblem = ({ issue, day, shift, dayLabel }, lang = "en") => {
  const i = lang === "ar" ? 0 : 1;
  const where = [dayLabel || DAYS[day]?.[i], SHIFTS[shift]?.[i]].filter(Boolean).join(" — ");
  const prefix = where ? `${where}: ` : "";
  if (issue === "incomplete") {
    return prefix + (lang === "ar" ? "أدخل وقت البداية ووقت النهاية معاً." : "Enter both the start and the end time.");
  }
  if (issue === "format") {
    return prefix + (lang === "ar" ? "صيغة الوقت غير صحيحة (س:د)." : "The time format is not valid (HH:MM).");
  }
  if (issue === "weekday") {
    return lang === "ar" ? "يوم غير معروف في أوقات العمل." : "Unknown day in the working hours.";
  }
  return lang === "ar" ? "أوقات العمل غير مكتملة." : "The working hours are incomplete.";
};

// Message for a failed request: hours details when the server sent them,
// otherwise the server's own message.
export const hoursErrorMessage = (error, lang = "en") =>
  error?.details?.issue ? describeHoursProblem(error.details, lang) : error?.message || "";
